import { useContext } from 'react';

import * as SnapshotContext from '../context/snapshotContext';

export const useSnapshotRefresher = () => {
    const { refreshSnapshot } = useContext(SnapshotContext.Context);

    return refreshSnapshot;
};
